<template>
    <div class="top_con">
       <el-form :inline="true" class="demo-form-inline">
           <el-row :gutter="10">
                <el-form-item label="搜索内容">
                    <el-input v-model="search_cont"  placeholder="请输入姓名或者岗位类别"></el-input>
                </el-form-item>

                     <el-form-item label="来源">
                        <el-select v-model="source_desc" placeholder="请选择"  >
                            <el-option label="后台" :value="1" ></el-option>
                            <el-option label="小程序" :value="2" ></el-option>
                        </el-select>
                    </el-form-item>

                <div style="float:right;">
                    <el-form-item>
                        <el-upload  class="upload-demo" ref="upload" :show-file-list="false" :data="{userId:user.uid}" action="https://hmd.18durensheng.com/admin_mingdan/importMD.html" :on-success="cg">
                            <el-button slot="trigger" type="primary">导入</el-button>
                        </el-upload>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">查询</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="info" @click="clearS">重置</el-button>
                    </el-form-item>
                </div>
           </el-row>
        </el-form>
        <el-button type="primary" @click="add_md(1)" style="margin-top:20px;" v-if="true1==true">添加</el-button>
        <el-table  ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}" @selection-change="handleSelectionChange" max-height="600px">
            <el-table-column  prop="id"  label="ID"></el-table-column>
            <el-table-column  prop="gangwei"  label="岗位类别"></el-table-column>
            <el-table-column prop="name"  label="姓名"></el-table-column>
            <el-table-column prop="zhiwei"  label="地点" ></el-table-column>
            <el-table-column prop="img"  label="上榜人照片" >
                <template slot-scope="scope">
                    <el-image  style="width:40px;height:30px;margin:0 auto;" :src="scope.row.img" :preview-src-list="scope.row.imgs"></el-image>
                 </template>
            </el-table-column>
            <el-table-column prop="zcost"  label="作品链接" >
                <template slot-scope="scope">
                    <el-link type="primary" @click="look(1,scope.row)">查看</el-link>
                </template>
            </el-table-column>
            <el-table-column prop="dcost"  label="推荐理由" >
                <template slot-scope="scope">
                <el-link type="primary" @click="look(2,scope.row)">查看</el-link>
                </template>
            </el-table-column>
            <el-table-column prop="referrer"  label="推荐人" ></el-table-column>
            <el-table-column prop="reguser"  label="注册人" ></el-table-column>
            <el-table-column prop="sprice"  label="评审">
                <template slot-scope="scope">
                    <el-link type="primary" @click="look(3,scope.row)">查看</el-link>
                </template>
            </el-table-column>
            <el-table-column prop="source_desc"  label="来源" ></el-table-column>
            <el-table-column prop="is_red" label="评审状态">
                <template slot-scope="scope">
                    <span v-if="scope.row.is_red==0">未通过</span>
                    <span v-if="scope.row.is_red==1">已通过</span>
                    <span v-if="scope.row.is_red==2">未评分</span>
                </template>
            </el-table-column>
            <el-table-column   label="操作" style="text-align:center"> 
                <template slot-scope="scope">
                    <el-link :underline="false" @click="add_md(2,scope.row.id)" style="margin-right:20px;" size="small" v-if="true2==true">编辑</el-link>
                    <el-link :underline="false" type="danger" @click="del(scope.row.id)" size="small" v-if="true3==true">删除</el-link>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination  background layout="prev, pager, next"  :pager-count="5" :page-size="value" :total='total' @current-change="handleCurrentChange"></el-pagination>
        <div>
            <el-dialog :title="zp_tit" :visible.sync="dialogFormVisible" width="36%">
                <el-input v-model="cknum" :disabled="true" v-if="tit_type==1"></el-input>
                <div class="wenzi" v-else-if="tit_type==2" v-html="jianjie"></div>
                <div class="wenzi2" v-else-if="tit_type==3">
                    <el-table  ref="multipleTable" :data="ps.list" tooltip-effect="dark" style="width: 100%" :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}" max-height="300px">
                        <el-table-column prop="hangye"  label="沟通能力"></el-table-column>
                        <el-table-column prop="xingjiabi" label="创意能力"></el-table-column>
                        <el-table-column prop="koucai" label="项目投入度"></el-table-column>
                        <el-table-column prop="zuopin"  label="时间观念" ></el-table-column>
                        <el-table-column prop="qita"  label="制作配合度" ></el-table-column>
                        <el-table-column prop="avg"  label="平均分" ></el-table-column>
                        <el-table-column prop="username"  label="评审人"></el-table-column>
                    </el-table>
                    <p style="padding-left:30px;">评分结果：{{ps.avg}}</p>
                </div>
                <div slot="footer" class="dialog-footer" style="text-align:center;">
                    <el-button type="primary" @click="dialogFormVisible = false">确认</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import {newList,getList,editRk,CkC,getList_del,getList_ps} from '@/utils/api'
export default {
    data(){
        return{
            user:{},
            houseLis:[],
            ckid:'',
            cknum:'',
            ps:[],
            jianjie:'',
            ruKu:'',
            jieYu:'',
            zMoney:'',
            search_cont:'',
            dialogFormVisible:false,
            chuKu:false,
            zp_tit:"作品链接",
            tit_type:0,
            srcList:[
                'https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg',
                'https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg'
            ],
            formLabelWidth: '120px',
            value:10,
            total:12,
            multipleSelection:[],
            tableData: [],
            fileList: [],
            pageNum:1,
            true1:false,
            true2:false,
            true3:false,
            source_desc:'',
        }
    },
    methods:{
        handleCurrentChange(val){
            this.pageNum=val;
            let param ={
                numPerPage:this.value,
                pageNum:val,
                searchCont:this.search_cont,
                source_desc:this.source_desc
            }
            getList(param).then(res=>{
                this.total=res.total
                this.tableData=res.list
                if(res.qx.indexOf('1')!=-1){
                    this.true1=true;
                }
                if(res.qx.indexOf('2')!=-1){
                    this.true2=true;
                }
                if(res.qx.indexOf('3')!=-1){
                    this.true3=true;
                }
            });
        },
        add_md(idx,id){
            this.$router.push({
                path:'/NameList',
                query:{
                    idx:idx,
                    id:id
                }
            })
        },
        onSubmit(){
            let param ={
                numPerPage:this.value,
                pageNum:'1',
                searchCont:this.search_cont,
                source_desc:this.source_desc
            }
            getList(param).then(res=>{
                this.total=res.total,
                this.tableData=res.list,
                this.zMoney=res.total_zcost
            });
        },
        look(idx,row){
            this.dialogFormVisible=true
            if(idx==1){
                this.zp_tit="作品链接";
                this.tit_type=1;
                this.cknum=row.link
            }else if(idx==2){
                this.zp_tit="推荐理由";
                this.tit_type=2;
                this.jianjie=row.intro
            }else if(idx==3){
                this.zp_tit="评审";
                this.tit_type=3;
                getList_ps({id:row.id}).then(res=>{
                    console.log(res)
                   this.ps=res;
                })
            }
        },
        handleSelectionChange(val){
            this.multipleSelection = val;
        },
        war(id){
            this.chuKu=true;
            this.ckid=id
        },
        subCk(){
            let user=JSON.parse(localStorage.getItem('userInfo'))
            let param ={
                userid:user.uid,
                id:this.ckid,
                num:this.cknum
            }
            CkC(param).then(res=>{
                this.chuKu=false;
                getList(param).then(res=>{
                    this.total=res.total,
                    this.tableData=res.list,
                    this.zMoney=res.total_zcost
                })
            })
        },
        Submit(){
            let user=JSON.parse(localStorage.getItem('userInfo'))
            let param ={
                userid:user.uid,
                listInfo:this.form,
                img:this.fileList
            }
            newList(param).then(res=>{
                this.dialogFormVisible=false;
                getList(param).then(res=>{
                    this.total=res.total,
                    this.tableData=res.list,
                    this.zMoney=res.total_zcost
                })
            })
        },
        clearS(){
            this.search_cont=''
            this.source_desc=''
            getList().then(res=>{
                this.total=res.total,
                this.tableData=res.list
            });
        },
        editS(){
            let user=JSON.parse(localStorage.getItem('userInfo'))
            let param ={
                userid:user.uid,
                listInfo:this.form,
                img:this.fileList
            }
            editRk(param).then(res=>{
                this.dialogFormVisible=false;
                getList(param).then(res=>{
                    this.total=res.total,
                    this.tableData=res.list,
                    this.zMoney=res.total_zcost
                })
            })
        },

        del(id){
            this.$confirm('确定删除, 是否继续?', '删除', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    let user=JSON.parse(localStorage.getItem('userInfo'))
                    let param ={
                        userId:user.uid,
                        id:id
                    }
                    getList_del(param).then(res=>{
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        getList().then(res=>{
                            this.total=res.total
                            this.tableData=res.list
                            if(res.qx.indexOf('1')!=-1){
                                this.true1=true;
                            }
                            if(res.qx.indexOf('2')!=-1){
                                this.true2=true;
                            }
                            if(res.qx.indexOf('3')!=-1){
                                this.true3=true;
                            }
                        })
                    });
                   
               
                }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        },
        cg(response){
             console.log(response)
            if(response.code==200){
               this.$message({
                    type: 'success',
                    message: '上传成功'
                });    
                getList().then(res=>{
                    this.total=res.total
                    this.tableData=res.list
                    if(res.qx.indexOf('1')!=-1){
                        this.true1=true;
                    }
                    if(res.qx.indexOf('2')!=-1){
                        this.true2=true;
                    }
                    if(res.qx.indexOf('3')!=-1){
                        this.true3=true;
                    }
                })
            }else if(response.code==201){
                this.$message({
                    type: 'info',
                    message: '上传失败'
                });    
            }   
           
        }
    },
    mounted(){
        this.user=JSON.parse(localStorage.getItem('userInfo'))
        let param ={
            numPerPage:this.value,
            pageNum:this.pageNum,
            searchCont:this.search_cont,
            source_desc:this.source_desc
        }
        getList(param).then(res=>{
            this.total=res.total
            this.tableData=res.list
            if(res.qx.indexOf('1')!=-1){
                this.true1=true;
            }
            if(res.qx.indexOf('2')!=-1){
                this.true2=true;
            }
            if(res.qx.indexOf('3')!=-1){
                this.true3=true;
            }
        });
    }
}

</script>
<style scoped>
    .top_con{
        width:100%;
        height:auto;
        padding:20px;
        box-sizing:border-box;
    }
    .el-form-item{
        vertical-align:middle;
        margin-right:20px;
    }
    .el-input{
        /* width:193px; */
        margin-right:10px;
    }
    .el-pagination {
        text-align: right;
        margin-top: 20px;
    }
    .edit_width .el-upload-list{
        width:260px;
    }
    .el-image{
        margin-right:30px;
    }
    .wenzi{
        width:100%;
        height:100px;
        border:2px solid #e5e5e5;
    }
    table{
        margin:0 auto;
        width:100%;
        margin: 0;
    }
    table,table tr td {
            border: 1px solid #DEDEDE;
            margin: 0;
            color: #000000;
            padding: 10px 10px;
            box-sizing:border-box;
            font-size: 14px;
            font-weight: 400;
			font-family: Microsoft YaHei;
            border-collapse: collapse;
            text-align:center;
        }
</style>



// WEBPACK FOOTER //
// src/components/Warehousing.vue